import React from 'react';
import { motion } from 'framer-motion';

const PhoneMockups = () => {
  return (
    <div className="relative h-[580px] lg:h-[700px] w-full max-w-[520px] mx-auto lg:mx-0 flex items-center justify-center">
      {/* Tertiary Screenshot (Left/Back) */}
      <motion.div 
        initial={{ opacity: 0, x: -60, rotate: -12, scale: 0.9 }}
        animate={{ opacity: 1, x: -110, rotate: -8, scale: 0.95 }}
        transition={{ duration: 1, delay: 0.4, ease: "easeOut" }}
        className="absolute w-[200px] sm:w-[240px] rounded-[32px] overflow-hidden shadow-2xl z-10 border-[6px] border-aubergine/10 bg-white"
      >
        <img 
          src="https://media-manager-c.questera.ai/greta-media/cb626cea481d7a3becbea24c974d0b65e32a5ba3c552e12f2d9768775a77545899023c8e9d705cdece5224b19de37c3e/images/aW1hZ2UvcG5n/470077c706d0a9d499aeab8c6d61ee29.png" 
          alt="Prayer Times" 
          className="w-full h-auto object-cover" 
        />
      </motion.div>

      {/* Secondary Screenshot (Right/Mid) */}
      <motion.div 
        initial={{ opacity: 0, x: 60, rotate: 12, scale: 0.9 }}
        animate={{ opacity: 1, x: 110, rotate: 8, scale: 0.95 }}
        transition={{ duration: 1, delay: 0.2, ease: "easeOut" }}
        className="absolute w-[200px] sm:w-[240px] rounded-[32px] overflow-hidden shadow-2xl z-20 border-[6px] border-aubergine/10 bg-white"
      >
        <img 
          src="https://media-manager-c.questera.ai/greta-media/cb626cea481d7a3becbea24c974d0b65e32a5ba3c552e12f2d9768775a77545899023c8e9d705cdece5224b19de37c3e/images/aW1hZ2UvcG5n/90f0babce36d354e8afe78add75ac3bf.png" 
          alt="Fasting Tracker" 
          className="w-full h-auto object-cover" 
        />
      </motion.div>

      {/* Primary Screenshot (Center/Front) */}
      <motion.div 
        initial={{ opacity: 0, y: 50, scale: 0.8 }}
        animate={{ opacity: 1, y: 0, scale: 1 }}
        transition={{ duration: 0.8, ease: "backOut" }}
        className="absolute w-[240px] sm:w-[280px] rounded-[40px] overflow-hidden shadow-[0_45px_100px_-20px_rgba(42,23,70,0.5)] z-30 border-[8px] border-aubergine bg-white"
      >
        <img 
          src="https://media-manager-c.questera.ai/greta-media/cb626cea481d7a3becbea24c974d0b65e32a5ba3c552e12f2d9768775a77545899023c8e9d705cdece5224b19de37c3e/images/aW1hZ2UvcG5n/d7d7f1c063beaf8957071f85d4a34c8b.png" 
          alt="Cycle Dashboard" 
          className="w-full h-auto object-cover" 
        />
        {/* Notch simulation */}
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-32 h-6 bg-aubergine rounded-b-2xl z-40" />
      </motion.div>
    </div>
  );
};

export default PhoneMockups;